import "./App.css";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "./utils/ScrollToTop";
import Login from "./v2/pages/auth/login-page/login-page.tsx";
import ForgotPassword from "./v2/pages/auth/forgot-password-page/forgot-password-page.tsx";
import ResetPassword from "./v2/pages/auth/reset-password-page/reset-password-page.tsx";
import OnboardPostJoinPage from "./v2/pages/onboard-post-join/onboard-post-join-page.tsx";
import CreateEmployeePage from "./v2/pages/onboard-pre-join/create-employee-page.tsx";
import UsPreJoinPage from "./v2/pages/onboarding/us/pre-join/us-pre-join-page.tsx";
import UsPostJoinPage from "./v2/pages/onboarding/us/post-join/us-post-join-page.tsx";
import { getAuthToken } from "./utils/Storage";
import { ToastContainer } from "react-toastify";
import { Toaster } from "sonner";
// import Home from "./Pages/Home";
import Home from "./v2/components/layout/home.tsx";
import MaintenancePage from "./v2/pages/maintenance-page.tsx";
import MigrationPage from "./v2/pages/migration-page.tsx";

function App() {
  const { pathname } = useLocation();
  const path = String(pathname);
  const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === "true";
  const migrationMode = process.env.REACT_APP_MIGRATION_MODE === "true";

  if (maintenanceMode) {
    return <MaintenancePage />;
  }

  if (migrationMode) {
    return <MigrationPage />;
  }

  function RequireAuth({ children, redirectTo }) {
    let accessToken = getAuthToken("accessToken");
    return accessToken ? <Navigate to={redirectTo} /> : children;
  }

  return (
    <>
      {path.includes("/dashboard") ? (
        <Home />
      ) : (
        <Routes>
          <Route path="*" exact element={<Navigate to="/" />} />
          <Route
            path="/"
            exact
            element={
              <RequireAuth redirectTo="/dashboard">
                <Login />
              </RequireAuth>
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/onboard-post-join" element={<OnboardPostJoinPage />} />
          <Route path="/create-employee" element={<CreateEmployeePage />} />
          <Route path="/create-employee/us" element={<UsPreJoinPage />} />
          <Route path="/onboarding/us/pre-join" element={<UsPreJoinPage />} />
          <Route path="/onboard-post-join/us" element={<UsPostJoinPage />} />
        </Routes>
      )}
      <ToastContainer />
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          success: {
            duration: 1000,
          },
          error: {
            duration: 2000,
          },
        }}
      />
      <ScrollToTop />
    </>
  );
}

export default App;
